import React from "react";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../../../components/MaterialBox";
import MaterialTypography from "../../../../../../components/MaterialTypography";
import MaterialSelect from "../../../../../../components/MasterSelect";
const TaxDetails = ({ employeeData, handleEmployeeDataChange, togglePage }) => {
  const taxRegimeOptions = [
    { value: "New Tax Regime", label: "New Tax Regime" },
    { value: "Old Tax Regime", label: "Old Tax Regime" },
  ];

  return (
    <MaterialBox>
      <MaterialTypography variant="h5">Tax info</MaterialTypography>
      <Grid marginTop={1} container spacing={2} alignItems="center">
        <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Tax regime<span style={{color:"red"}} >*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialSelect
            name="taxRegime"
            value={employeeData.taxRegime}
            onChange={handleEmployeeDataChange}
            options={taxRegimeOptions}
            menuPlacement="auto"
            label="Select tax regime"
            customStyles={{ paddingDisabled: true }}
            error={employeeData.taxRegimeStatus === "error"}
            success={employeeData.taxRegimeStatus === "success"}
            isDisabled={togglePage.view}
          />
        </Grid>
      </Grid>
    </MaterialBox>
  );
};

export default TaxDetails;
